var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187.59pt",
    height: "320pt",
    viewBox: "-106 0 187.59 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.625
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.415 292.41h-77.241c-10.063 0-19.465 2.8418-27.588-1.8652v12.898c0 9.1431 7.4121 16.553 16.553 16.553h99.309c9.1431 0 16.553-7.4097 16.553-16.553v-12.898c-8.1226 4.707-17.522 1.8652-27.585 1.8652z",
    fill: "#0b1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.897 0h-66.208c-6.0864 0.01709-11.016 4.9487-11.033 11.035v60.964c1.8213-0.16602 3.6401-0.27588 5.5176-0.27588h77.241c1.875 0 3.6963 0.10986 5.5176 0.27588v-60.964c-0.01953-6.0864-4.9487-11.018-11.035-11.035zm-11.035 38.621c0 3.0469-2.4707 5.5176-5.5176 5.5176h-33.103c-3.0469 0-5.5176-2.4707-5.5176-5.5176v-11.035c0-3.0469 2.4707-5.5176 5.5176-5.5176h33.103c3.0469 0 5.5176 2.4707 5.5176 5.5176z",
    fill: "#3771c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-50.827 66.206h77.241c30.471 0 55.171 24.702 55.171 55.173v121.38c0 30.471-24.7 55.173-55.171 55.173h-77.241c-30.471 0-55.173-24.702-55.173-55.173v-121.38c0-30.471 24.702-55.173 55.173-55.173z",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-12.206 248.28c-11.035 0-44.138-2.0923-44.138-33.484 0.49805-10.356 5.0562-20.1 12.688-27.119 0.10254-0.0928 0.25635-0.10986 0.37598-0.0391 0.11963 0.0708 0.17822 0.21484 0.14404 0.34912-1.1816 3.4546-3.9502 14.25 8.8281 14.25 4.4141 0 8.8257-2.0898 8.8257-10.481 0-8.3936-11.033-16.746-11.033-29.304 0-13.926 8.3252-33.655 24.275-35.569 0.28076-0.0439 0.5542 0.10743 0.6665 0.36866 0.10986 0.26123 0.0293 0.56396-0.19775 0.73486-4.0601 2.4658-6.687 6.7334-7.0557 11.47 0 25.115 50.759 33.484 50.759 75.339 0 31.392-33.105 33.484-44.138 33.484z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.33686 0 0 .33686 -98.443 96.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m395.8 160.1c-3.3-38.7-35.4-68.099-74.7-68.099h-130.2c-39.3 0-71.4 29.399-74.7 68.099l-26.7 291.9h333z",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.5 452h-166.5v-360h65.1c39.3 0 71.4 29.399 74.7 68.099z",
    fill: "#f03800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 227,
    width: 30,
    height: 150,
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 227,
    width: 15,
    height: 150,
    fill: "#f03800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    width: 30,
    height: 60,
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.81 68.061 364.82 53.061 394.88 1 420.87 16",
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.4999 .8661 -.8661 .4999 363.6 -332.46)",
    x: 454.69,
    y: 116.08,
    width: 30.005,
    height: 65.082,
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.19 68.061 91.132 16 117.12 1 147.18 53.061",
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.8661 .4999 -.4999 .8661 79.961 -1.2476)",
    x: 9.767,
    y: 133.62,
    width: 65.083,
    height: 30.005,
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 210.2-75-37.5v168.6l75-37.5 75 37.5v-168.6z",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 362,
    width: 210,
    height: 75,
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    width: 15,
    height: 60,
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331 341.3 256 303.8 256 210.2 331 172.7",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 362,
    width: 105,
    height: 75,
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.001,
    y: 422,
    width: 390,
    height: 90,
    fill: "#575f64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 422,
    width: 195,
    height: 90,
    fill: "#32393f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasAlarm);
export default __webpack_public_path__ + "static/media/gas_alarm.be8a44b5131f550e5d630efd20ef98d8.svg";
export { ForwardRef as ReactComponent };